export {
  useActiveTyping,
  useActivities,
  useActivityKeys,
  useActivityKeysByRead,
  useAvatarForBot,
  useAvatarForUser,
  useBuildRenderActivityCallback,
  useByteFormatter,
  useCapabilities,
  useConnectivityStatus,
  useCreateActivityRenderer,
  useCreateActivityStatusRenderer,
  useCreateAttachmentForScreenReaderRenderer,
  useCreateAvatarRenderer,
  useCreateScrollToEndButtonRenderer,
  useDateFormatter,
  useDebouncedNotifications,
  useDictateAbortable,
  useDictateInterims,
  useDictateState,
  useDirection,
  useDisabled,
  useDismissNotification,
  useEmitTypingIndicator,
  useFileDropZone,
  useFocus,
  useGetActivitiesByKey,
  useGetActivityByKey,
  useGetHasAcknowledgedByActivityKey,
  useGetKeyByActivity,
  useGetKeyByActivityId,
  useGetSendTimeoutForActivity,
  useGrammars,
  useGroupActivities,
  useGroupActivitiesByName,
  useGroupTimestamp,
  useLanguage,
  useLastAcknowledgedActivityKey,
  useLastReadActivityKey,
  useLocalizer,
  useMakeThumbnail,
  useMarkActivityAsSpoken,
  useMarkActivityKeyAsRead,
  useMarkAllAsAcknowledged,
  useMicrophoneButtonClick,
  useMicrophoneButtonDisabled,
  useNotifications,
  useObserveScrollPosition,
  useObserveTranscriptFocus,
  usePerformCardAction,
  usePonyfill,
  usePostActivity,
  useReferenceGrammarID,
  useRegisterFocusSendBox,
  useRelativeTimeFormatter,
  useRenderAttachment,
  useRenderMarkdownAsHTML,
  useRenderToast,
  useRenderTypingIndicator,
  useScrollDown,
  useScrollTo,
  useScrollToEnd,
  useScrollUp,
  useSendBoxAttachments,
  useSendBoxSpeechInterimsVisible,
  useSendBoxValue,
  useSendEvent,
  useSendFiles,
  useSendMessage,
  useSendMessageBack,
  useSendPostBack,
  useSendStatusByActivityKey,
  useSendTimeoutForActivity,
  useSendTypingIndicator,
  useSetNotification,
  useShouldReduceMotion,
  useShouldSpeakIncomingActivity,
  useStartDictate,
  useStartVoice,
  useStopDictate,
  useStopVoice,
  useStyleOptions,
  useStyleSet,
  useSubmitSendBox,
  useSuggestedActions,
  useSuggestedActionsHooks,
  useTextBoxSubmit,
  useTextBoxValue,
  useTimeoutForSend,
  useTrackDimension,
  useTrackEvent,
  useTrackException,
  useTrackTiming,
  useTransformHTMLContent,
  useTypingIndicatorVisible,
  useUIState,
  useUserID,
  useUsername,
  useVoiceRecordingMuted,
  useVoiceSelector,
  useVoiceState,
  useWebSpeechPonyfill,
  type DropZoneState,
  type SendBoxFocusOptions
} from 'botframework-webchat-component/hook.js';
